export enum TooltipPositionEnum{
    LEFT = "LEFT",
    RIGHT = "RIGHT",
    AUTO = "AUTO"
}